exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media screen and (max-width: 750px) {\n.title[data-v-b541f8d6] {\n    margin: 0;\n}\n}\n", ""]);

